import { superAdminDigilockerRedirectUrl } from './environment.shared';

const appUrl = 'https://backoffice.brickhubcrm.com';

export const environment = {
  production: false,
  apiUrl: 'https://super-admin.brickhub-api.katdev.com/api',
  integrationsApiUrl: 'https://brickhub-api.katdev.com/api',
  appName: 'Brickhub Super Admin',
  tenantBaseDomain: 'brickhub.katdev.com',
  digilockerAllowLocalhostRedirect: false,
  digilockerLocalTunnelUrl: '',
  digilockerRedirectUrl: superAdminDigilockerRedirectUrl(appUrl),
};
